import { Checkbox } from 'antd';
import React, { useEffect, useState } from 'react';

interface ActiveCheckboxCellProps {
  value: boolean;
  onSave: (isActive: boolean) => Promise<unknown>;
}

/** Inline active toggle for the products table: flips right away, reverts if the save fails. */
export const ActiveCheckboxCell: React.FC<ActiveCheckboxCellProps> = ({ value, onSave }) => {
  const [checked, setChecked] = useState(value);
  const [saving, setSaving] = useState(false);

  // Pick up the fresh value after a refetch.
  useEffect(() => {
    setChecked(value);
  }, [value]);

  const toggle = async (next: boolean) => {
    setChecked(next);
    setSaving(true);
    try {
      await onSave(next);
    } catch {
      setChecked(value);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Checkbox checked={checked} disabled={saving} onChange={(e) => toggle(e.target.checked)} />
  );
};
